import React from 'react';
import solution from '../../../assets/images/games/zdar-kids-game/reseni-pdf.pdf';

export default function ZdarKidsWorkbookSolution() {
    return (
        <React.Fragment>
            <div className="full">
                <iframe src={`${solution}#view=fitH`} title="testPdf" height="100%" width="100%" />
            </div>
        </React.Fragment>
    );
}
